import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IMina, IMinaInitialState } from "./minaModel";
import {
  createMina,
  deleteMina,
  deleteMinaOrderItems,
  findAllMina,
  getMinaById,
  updateMina,
} from "./services/mina.services";

const initialState: IMinaInitialState = {
  loading: false,
  error: "",
  MinaID: null,
  MinaOrderItemIndex: null,
  MinaOrderSelectionDialog: false,
  MinaList: [],
  MinaDetail: {
    issue_date: new Date(),
    approx_delivery_date: "",
    karigar_id: null,
    mina_issue_order: [],
  },
  FilterMina: {
    karigar_name: "",
    karigar_nick_name: "",
    issue_date: "",
    approx_delivery_date: "",
  },
};

const minaSlice = createSlice({
  name: "mina",
  initialState,
  reducers: {
    setMinaID: (state, action) => {
      state.MinaID = action.payload;
    },
    clearMinaDetail: (state) => {
      state.MinaDetail = initialState.MinaDetail;
    },
    setMinaOrderItemIndex: (state, action) => {
      state.MinaOrderItemIndex = action.payload;
    },
    setFilterMina: (state, action) => {
      state.FilterMina = action.payload;
    },
    clearFilterMina: (state) => {
      state.FilterMina = initialState.FilterMina;
    },
    openMinaOrderSelectionDialog: (state) => {
      state.MinaOrderSelectionDialog = true;
    },
    closeMinaOrderSelectionDialog: (state) => {
      state.MinaOrderSelectionDialog = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(findAllMina.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllMina.fulfilled,
      (state, action: PayloadAction<IMina[]>) => {
        state.loading = false;
        state.MinaList = action.payload || [];
      }
    );
    builder.addCase(findAllMina.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.MinaList = [];
    });

    builder.addCase(createMina.pending, (state) => {
      state.loading = false;
      state.error = "";
    });
    builder.addCase(createMina.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createMina.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateMina.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateMina.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateMina.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteMina.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteMina.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteMina.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getMinaById.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getMinaById.fulfilled, (state, action: any) => {
      state.loading = false;
      state.MinaDetail = action.payload;
    });
    builder.addCase(getMinaById.rejected, (state, action) => {
      state.loading = false;
      state.MinaDetail = initialState.MinaDetail;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteMinaOrderItems.pending, (state) => {
      state.loading = false;
      state.error = "";
    });
    builder.addCase(deleteMinaOrderItems.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteMinaOrderItems.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearMinaDetail,
  setMinaID,
  setMinaOrderItemIndex,
  clearFilterMina,
  setFilterMina,
  closeMinaOrderSelectionDialog,
  openMinaOrderSelectionDialog,
} = minaSlice.actions;
export default minaSlice.reducer;
